import CheckboxSelectAll from 'stimulus-checkbox-select-all'
import Rails from '@rails/ujs'

export default class extends CheckboxSelectAll {
    static targets = ["bulkActionsMenu", "checkedCounter"]

    connect() {
        super.connect()
        // Get all checked checkboxes
        this.checked
        // Get all unchecked checkboxes
        this.unchecked
    }

    handleSingleSelect(event) {
        if(this.checked.length > 0) {
            this.showMenu()
        } else {
            this.hideMenu()
        }
        this.updateCheckedCount();
    }

    handleSelectAll(event) {
        if(event.target.checked) {
            let self = this;
            self.updateCheckedCount(this.checked.length+this.unchecked.length);
            self.showMenu();
        } else {
            this.updateCheckedCount();
            this.hideMenu()
        }
    }
    
    update_as_done(event) {
        event.preventDefault();
        if(window.confirm(this.getConfirmMsgParam(event)) && this.checked.length > 0) {
            this.doAjaxRequest('done', this.checked, this.getRedirectUrlParam(event));
        }
    }

    update_as_in_progress(event) {
        event.preventDefault();
        if(window.confirm(this.getConfirmMsgParam(event)) && this.checked.length > 0 ) {
            this.doAjaxRequest('in_progress', this.checked, this.getRedirectUrlParam(event));
        }
    }

    update_as_confirmed(event) {
        event.preventDefault();
        if(window.confirm(this.getConfirmMsgParam(event)) && this.checked.length > 0) {
            this.doAjaxRequest('confirmed', this.checked, this.getRedirectUrlParam(event));
        }
    }

    showModalBulkUpdateAsArchive(event) {
        event.preventDefault();
        if(this.checked.length > 0) {
            this.doShowModalAjaxRequest("bulk_update_as_archive", this.checked, this.getRedirectUrlParam(event));
        }
    }

    showModalBulkUpdateAsUnarchive(event) {
        event.preventDefault();
        if(this.checked.length > 0) {
            this.doShowModalAjaxRequest("bulk_update_as_unarchive", this.checked, this.getRedirectUrlParam(event));
        }
    }

    updateCheckedCount(count) {
        this.checkedCounterTarget.innerHTML = count || this.checked.length;
    }

    showMenu() {
        this.bulkActionsMenuTarget.classList.remove("d-none");
    }
    
    hideMenu() {
        this.bulkActionsMenuTarget.classList.add("d-none");
    }

    doAjaxRequest(action, checkboxes, redirectUrl) {
        let data = new FormData();
        checkboxes.forEach((checkbox) => data.append("bulk_ids[]", checkbox.value));
        data.append("redirect_url", redirectUrl);
        Rails.ajax({
            type: "PUT",
            url: 'orders/bulk/'+action,
            data: data
        });
    }

    doShowModalAjaxRequest(action, checkboxes, redirectUrl) {
        let params = new URLSearchParams();
        checkboxes.forEach((checkbox) => params.append("bulk_ids[]", checkbox.value));
        params.append("redirect_url", redirectUrl);

        Rails.ajax({
            type: "GET",
            url: 'orders/bulk/'+action,
            data: params
        });
    }
    
    getRedirectUrlParam(event) {
        return event.currentTarget.dataset['redirectUrlParam'];
    }

    getConfirmMsgParam(event) {
        return event.currentTarget.dataset['confirmMsgParam'];
    }
}